module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "content"
  }, [_c('h1', [_vm._v("Hi there! We're an awesome group of creatives from a variety of\ndifferent backgrounds with a variety of skills.")]), _c('section', {
    staticClass: "email"
  }, [_c('h2', {
    staticClass: "aside-title"
  }, [_vm._v("CONTACT US")]), _vm._m(0), _c('div', {
    staticClass: "contact"
  }, [_c('p', {
    staticClass: "contact-address"
  }, [_vm._v("9000456,")]), _c('p', {
    staticClass: "contact-address"
  }, [_vm._v("2426 Sing Street,")]), _c('p', {
    staticClass: "contact-address"
  }, [_vm._v("Quesnel BC,")]), _c('p', {
    staticClass: "contact-address"
  }, [_vm._v("V2J 4P7, Canada.")]), _c('ul', {
    staticClass: "social-list"
  }, _vm._l((_vm.socials), function(social) {
    return _c('li', {
      staticClass: "social-item"
    }, [_c('a', {
      staticClass: "social-link"
    }, [_c('img', {
      attrs: {
        "src": require("../../assets/icons/" + social + ".svg")
      }
    })])])
  }))])]), _c('section', {
    staticClass: "map"
  }, [_c('h2', {
    staticClass: "aside-title"
  }, [_vm._v("FIND US")]), _c('iframe', {
    staticStyle: {
      "border": "0"
    },
    attrs: {
      "src": "https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d2403.    423905567938!2d-122.44442138383793!3d52.95878827989962!2m3!1f0!2f0!3f0!3m    2!1i1024!2i768!4f13.1!3m3!1m2!1s0x53870578f27359f5%3A0xf834004e0cdb5bf2!2    zU2luZyBTdCwgUXVlc25lbCwgQkMsINCa0LDQvdCw0LTQsA!5e0!3m2!1sru!2sru!4v14887    93347529",
      "width": "100%",
      "height": "450",
      "frameborder": "0",
      "allowfullscreen": "allowfullscreen"
    }
  })], 1)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('form', {
    staticClass: "email-form"
  }, [_c('div', {
    staticClass: "input-box"
  }, [_c('input', {
    staticClass: "input-line",
    attrs: {
      "type": "text",
      "placeholder": "First Name...",
      "name": "firstName"
    }
  }), _c('input', {
    staticClass: "input-line",
    attrs: {
      "type": "text",
      "placeholder": "Second Name...",
      "name": "secondName"
    }
  })]), _c('div', {
    staticClass: "input-box"
  }, [_c('input', {
    staticClass: "input-line",
    attrs: {
      "type": "email",
      "placeholder": "Email...",
      "name": "email"
    }
  }), _c('input', {
    staticClass: "input-line",
    attrs: {
      "type": "text",
      "placeholder": "Company...",
      "name": "company"
    }
  })]), _c('div', {
    staticClass: "input-box"
  }, [_c('textarea', {
    staticClass: "input-line",
    attrs: {
      "type": "text",
      "placeholder": "Text...",
      "name": "text"
    }
  })]), _c('a', {
    staticClass: "action-btn"
  }, [_vm._v("Submit")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?{"id":"data-v-2f5362f9"}!./~/vue-loader/lib/template-loader.js?raw&engine=pug!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/pages/Contacts.vue
// module id = 124
// module chunks = 0